export const position_select = [
  {
    value: "Professor",
    label: "Professor",
  },
  {
    value: "Lecturer",
    label: "Lecturer",
  },
  {
    value: "Instructor",
    label: "Instructor",
  },
  {
    value: "Director",
    label: "Director",
  },
  {
    value: "Assistant",
    label: "Assistant",
  },
];

export const seniority_select = [
  {
    value: "0",
    label: "1-10",
  },
  {
    value: "1",
    label: "10-20",
  },
  {
    value: "2",
    label: "20-30",
  },
  {
    value: "3",
    label: "30-40",
  },
  {
    value: "4",
    label: "40-50",
  },
  {
    value: "5",
    label: "50+",
  },
];

export const classification_select = [
  {
    value:
      "Carnegie Classifications/Basic 2021/Not classified, not in classification universe",
    label:
      "Carnegie Classifications/Basic 2021/Not classified, not in classification universe",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Transfer-High Traditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Transfer-High Traditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Transfer-Mixed Traditional/Nontraditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Transfer-Mixed Traditional/Nontraditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Transfer-High Nontraditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Transfer-High Nontraditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: Mixed Transfer/Career & Technical-High Traditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: Mixed Transfer/Career & Technical-High Traditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: Mixed Transfer/Career & Technical-Mixed Traditional/Nontraditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: Mixed Transfer/Career & Technical-Mixed Traditional/Nontraditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: Mixed Transfer/Career & Technical-High Nontraditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: Mixed Transfer/Career & Technical-High Nontraditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Career & Technical-High Traditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Career & Technical-High Traditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Career & Technical-Mixed Traditional/Nontraditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Career & Technical-Mixed Traditional/Nontraditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Career & Technical-High Nontraditional",
    label:
      "Carnegie Classifications/Basic 2021/Associate's Colleges: High Career & Technical-High Nontraditional",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Health Professions",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Health Professions",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Technical Professions",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Technical Professions",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Arts & Design",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Arts & Design",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Other Fields",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Two-Year: Other Fields",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Baccalaureate/Associate's Colleges: Associate's Dominant",
    label:
      "Carnegie Classifications/Basic 2021/Baccalaureate/Associate's Colleges: Associate's Dominant",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Doctoral Universities: Very High Research Activity",
    label:
      "Carnegie Classifications/Basic 2021/Doctoral Universities: Very High Research Activity",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Doctoral Universities: High Research Activity",
    label:
      "Carnegie Classifications/Basic 2021/Doctoral Universities: High Research Activity",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Doctoral/Professional Universities",
    label:
      "Carnegie Classifications/Basic 2021/Doctoral/Professional Universities",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Master's Colleges & Universities: Larger Programs",
    label:
      "Carnegie Classifications/Basic 2021/Master's Colleges & Universities: Larger Programs",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Master's Colleges & Universities: Medium Programs",
    label:
      "Carnegie Classifications/Basic 2021/Master's Colleges & Universities: Medium Programs",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Master's Colleges & Universities: Small Programs",
    label:
      "Carnegie Classifications/Basic 2021/Master's Colleges & Universities: Small Programs",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Baccalaureate Colleges: Arts & Sciences Focus",
    label:
      "Carnegie Classifications/Basic 2021/Baccalaureate Colleges: Arts & Sciences Focus",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Baccalaureate Colleges: Diverse Fields",
    label:
      "Carnegie Classifications/Basic 2021/Baccalaureate Colleges: Diverse Fields",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Baccalaureate/Associate's Colleges: Mixed Baccalaureate/Associate's",
    label:
      "Carnegie Classifications/Basic 2021/Baccalaureate/Associate's Colleges: Mixed Baccalaureate/Associate's",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Faith-Related Institutions",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Faith-Related Institutions",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Medical Schools & Centers",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Medical Schools & Centers",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Other Health Professions Schools",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Other Health Professions Schools",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Research Institution",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Research Institution",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Engineering and Other Technology-Related Schools",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Engineering and Other Technology-Related Schools",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Business & Management Schools",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Business & Management Schools",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Arts, Music & Design Schools",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Arts, Music & Design Schools",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Law Schools",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Law Schools",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Other Special Focus Institutions",
    label:
      "Carnegie Classifications/Basic 2021/Special Focus Four-Year: Other Special Focus Institutions",
  },
  {
    value:
      "Carnegie Classifications/Basic 2021/Tribal Colleges and Universities",
    label:
      "Carnegie Classifications/Basic 2021/Tribal Colleges and Universities",
  },
  {
    value: "Carnegie Classifications/Population Served/Women's Colleges",
    label: "Carnegie Classifications/Population Served/Women's Colleges",
  },
  {
    value:
      "Carnegie Classifications/Population Served/Historically Black Colleges and Universities",
    label:
      "Carnegie Classifications/Population Served/Historically Black Colleges and Universities",
  },
  {
    value:
      "Carnegie Classifications/Population Served/Hispanic Serving Institutions",
    label:
      "Carnegie Classifications/Population Served/Hispanic Serving Institutions",
  },
  {
    value:
      "Carnegie Classifications/Population Served/Tribal Colleges and Universities",
    label:
      "Carnegie Classifications/Population Served/Tribal Colleges and Universities",
  },
  {
    value:
      "Carnegie Classifications/Population Served/Minority Serving Institutions",
    label:
      "Carnegie Classifications/Population Served/Minority Serving Institutions",
  },
];

export const state_select = [
  {
    value: "AL",
    label: "Alabama",
  },
  {
    value: "AK",
    label: "Alaska",
  },
  {
    value: "AZ",
    label: "Arizona",
  },
  {
    value: "AR",
    label: "Arkansas",
  },
  {
    value: "CA",
    label: "California",
  },
  {
    value: "CO",
    label: "Colorado",
  },
  {
    value: "CT",
    label: "Connecticut",
  },
  {
    value: "DE",
    label: "Delaware",
  },
  {
    value: "FL",
    label: "Florida",
  },
  {
    value: "GA",
    label: "Georgia",
  },
  {
    value: "HI",
    label: "Hawaii",
  },
  {
    value: "ID",
    label: "Idaho",
  },
  {
    value: "IL",
    label: "Illinois",
  },
  {
    value: "IN",
    label: "Indiana",
  },
  {
    value: "IA",
    label: "Iowa",
  },
  {
    value: "KS",
    label: "Kansas",
  },
  {
    value: "KY",
    label: "Kentucky",
  },
  {
    value: "LA",
    label: "Louisiana",
  },
  {
    value: "ME",
    label: "Maine",
  },
  {
    value: "MD",
    label: "Maryland",
  },
  {
    value: "MA",
    label: "Massachusetts",
  },
  {
    value: "MI",
    label: "Michigan",
  },
  {
    value: "MN",
    label: "Minnesota",
  },
  {
    value: "MS",
    label: "Mississippi",
  },
  {
    value: "MO",
    label: "Missouri",
  },
  {
    value: "MT",
    label: "Montana",
  },
  {
    value: "NE",
    label: "Nebraska",
  },
  {
    value: "NV",
    label: "Nebraska",
  },
  {
    value: "NH",
    label: "New Hampshire",
  },
  {
    value: "NJ",
    label: "New Jersey",
  },
  {
    value: "NM",
    label: "New Mexico",
  },
  {
    value: "NY",
    label: "New York",
  },
  {
    value: "NC",
    label: "North Carolina",
  },
  {
    value: "ND",
    label: "North Carolina",
  },
  {
    value: "OH",
    label: "Ohio",
  },
  {
    value: "OK",
    label: "Oklahoma",
  },
  {
    value: "OR",
    label: "Oregon",
  },
  {
    value: "PA",
    label: "Pennsylvania",
  },
  {
    value: "RI",
    label: "Rhode Island",
  },
  {
    value: "SC",
    label: "South Carolina",
  },
  {
    value: "SD",
    label: "South Dakota",
  },
  {
    value: "TN",
    label: "Tennessee",
  },
  {
    value: "TX",
    label: "Texas",
  },
  {
    value: "UT",
    label: "Utah",
  },
  {
    value: "VT",
    label: "Vermont",
  },
  {
    value: "VA",
    label: "Virginia",
  },
  {
    value: "WA",
    label: "Washington",
  },
  {
    value: "WV",
    label: "West Virginia",
  },
  {
    value: "WI",
    label: "Wisconsin",
  },
  {
    value: "WY",
    label: "Wyoming",
  },
];
export const basic2021_select = [
  { value: 1, label: "Associate's Colleges: High Transfer-High Traditional" },
  {
    value: 2,
    label:
      "Associate's Colleges: High Transfer-Mixed Traditional/Nontraditional",
  },
  {
    value: 3,
    label: "Associate's Colleges: High Transfer-High Nontraditional",
  },
  {
    value: 4,
    label:
      "Associate's Colleges: Mixed Transfer/Career & Technical-High Traditional",
  },
  {
    value: 5,
    label:
      "Associate's Colleges: Mixed Transfer/Career & Technical-Mixed Traditional/Nontraditional",
  },
  {
    value: 6,
    label:
      "Associate's Colleges: Mixed Transfer/Career & Technical-High Nontraditional",
  },
  {
    value: 7,
    label: "Associate's Colleges: High Career & Technical-High Traditional",
  },
  {
    value: 8,
    label:
      "Associate's Colleges: High Career & Technical-Mixed Traditional/Nontraditional",
  },
  {
    value: 9,
    label: "Associate's Colleges: High Career & Technical-High Nontraditional",
  },
  { value: 10, label: "Special Focus Two-Year: Health Professions" },
  { value: 11, label: "Special Focus Two-Year: Technical Professions" },
  { value: 12, label: "Special Focus Two-Year: Arts & Design" },
  { value: 13, label: "Special Focus Two-Year: Other Fields" },
  {
    value: 14,
    label: "Baccalaureate/Associate's Colleges: Associate's Dominant",
  },
  { value: 15, label: "Doctoral Universities: Very High Research Activity" },
  { value: 16, label: "Doctoral Universities: High Research Activity" },
  { value: 17, label: "Doctoral/Professional Universities" },
  { value: 18, label: "Master's Colleges & Universities: Larger Programs" },
  { value: 19, label: "Master's Colleges & Universities: Medium Programs" },
  { value: 20, label: "Master's Colleges & Universities: Small Programs" },
  { value: 21, label: "Baccalaureate Colleges: Arts & Sciences Focus" },
  { value: 22, label: "Baccalaureate Colleges: Diverse Fields" },
  {
    value: 23,
    label:
      "Baccalaureate/Associate's Colleges: Mixed Baccalaureate/Associate's",
  },
  { value: 24, label: "Special Focus Four-Year: Faith-Related Institutions" },
  { value: 25, label: "Special Focus Four-Year: Medical Schools & Centers" },
  {
    value: 26,
    label: "Special Focus Four-Year: Other Health Professions Schools",
  },
  { value: 27, label: "Special Focus Four-Year: Research Institution" },
  {
    value: 28,
    label:
      "Special Focus Four-Year: Engineering and Other Technology-Related Schools",
  },
  {
    value: 29,
    label: "Special Focus Four-Year: Business & Management Schools",
  },
  { value: 30, label: "Special Focus Four-Year: Arts, Music & Design Schools" },
  { value: 31, label: "Special Focus Four-Year: Law Schools" },
  {
    value: 32,
    label: "Special Focus Four-Year: Other Special Focus Institutions",
  },
  { value: 33, label: "Tribal Colleges and Universities" },
  { value: -2, label: "Not classified, not in classification universe" },
];
export const time_range_select = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "recent",
    label: "Recent",
  },
];
